import { useState, useMemo } from 'react'
import { useQuery } from '@apollo/client'

import { Q_MEDIA_PATH } from 'graphql/query'

const useMediaPath = props => {
  const { refetch } = useQuery(Q_MEDIA_PATH)
  const [mediaPath, setMediaPath] = useState()
  const [isLoading, setIsLoading] = useState(true)

  useMemo(() => {
    refetch() &&
      refetch().then(res => {
        setMediaPath(res.data.getMediaPath)
        setIsLoading(false)
      })
  }, [])

  const getPath = path => {
    if (mediaPath && !isLoading) {
      const newPath = isLoading ? mediaPath : `${mediaPath}${path}`
      return newPath
    } else {
      // console.info(`media path could not be loaded for "${path}"`)
      return '/no-image-default.png'
    }
  }

  return getPath
}

export default useMediaPath
